<template>
	<div class="split-wrapper">
		<h2 class="section-title">拆分 GIF</h2>

    <div
      v-if="!gifUrl"
      class="upload-area"
      @click="triggerUpload"
    >
      <div class="upload-inner">
        <div class="upload-icon">🎞️</div>
        <div class="upload-text">
          {{ gifUrl ? '点击重新选择 GIF 文件' : '点击上传 GIF' }}
        </div>
        <div class="upload-hint">仅支持 GIF 格式，将拆分为多张图片</div>
      </div>
    </div>

    <input
      ref="gifInput"
      type="file"
      accept="image/gif"
      class="hidden-gif-input"
      @change="addGif"
    >

    <div v-if="gifUrl" class="original-preview">
      <div class="preview-title">原始 GIF</div>
      <img :src="gifUrl" alt="原始 GIF" class="original-gif">
    </div>

    <div v-if="gifUrl" class="actions">
      <button class="btn-primary" type="button" :disabled="isSplitting" @click="splitGif">
        {{ isSplitting ? '正在拆分...' : '拆分为图片' }}
      </button>
    </div>

    <div class="progress-container" v-if="isSplitting">
      <div class="progress-label">正在拆分 GIF... {{ splitProgress }}%</div>
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: splitProgress + '%' }"></div>
      </div>
    </div>

    <div v-if="img_list.length" class="frames-list">
      <div class="preview-title">拆分结果（共 {{ img_list.length }} 帧）</div>
      <div class="frames-grid">
        <div
          v-for="(item, index) in img_list"
          :key="index"
          class="frame-item"
        >
          <div class="frame-thumb">
            <img :src="item.url" :alt="`第 ${index + 1} 帧`">
          </div>
          <div class="frame-info">
            第 {{ index + 1 }} 帧
          </div>
          <button
            class="btn-small"
            type="button"
            @click.stop="downloadFrame(item)"
          >
            下载
          </button>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import SuperGif from  '../lib/libgif.js'
import { downloadFile } from './utils.js'
export default {
  data () {
    return {
      gifUrl: '',
      gifName: '',
      img_list: [],
      gifFile: null,
      isSplitting: false,
      splitProgress: 0,
      totalFrames: 0
		}
	},
	methods: {
    triggerUpload () {
      if (this.$refs.gifInput) {
        this.$refs.gifInput.click()
      }
    },
		addGif(e) {
      const file = e.target.files[0]
      if (!file) return
      this.gifFile = file
		  this.gifUrl = URL.createObjectURL(file)
			this.gifName = file.name
      this.img_list = []
		},
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      var n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
// 将canvas转换成file对象
    convertCanvasToImage(canvas, filename) {
      return this.dataURLtoFile(canvas.toDataURL('image/png'), filename);
    },
    pre_load_gif(gif_source) {
      var img_list = [];
      const wrapper = document.createElement('div')
      wrapper.style.position = 'fixed'
      wrapper.style.left = '-9999px'
      wrapper.style.top = '-9999px'

      const gifImg = document.createElement('img');
      // gif库需要img标签配置下面两个属性
      gifImg.setAttribute('rel:animated_src', URL.createObjectURL(gif_source))
      gifImg.setAttribute('rel:auto_play', '0')

      wrapper.appendChild(gifImg)
      document.body.appendChild(wrapper)

      // 新建gif实例（会在 wrapper 内部替换 img，不会影响页面可视区域）
      var rub = new SuperGif({ gif: gifImg } );
      rub.load(() => {
        var img_list = [];
        this.totalFrames = rub.get_length()
        this.splitProgress = 0
        
        for (let i=1; i <= rub.get_length(); i++) {
          // 遍历gif实例的每一帧
          rub.move_to(i);
          // 将每一帧的canvas转换成file对象
          let cur_file = this.convertCanvasToImage(rub.get_canvas(), gif_source.name.replace('.gif', '') + `-${i}`)
          img_list.push({
            file_name: cur_file.name,
            url: URL.createObjectURL(cur_file),
            file: cur_file,
          })
          // 更新进度
          this.splitProgress = Math.round((i / rub.get_length()) * 100)
        }
        this.img_list = img_list
        this.isSplitting = false
        this.splitProgress = 100
        // 解析完成后移除临时 wrapper，避免污染 DOM
        if (wrapper && wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper)
        }
      });
    },
    splitGif () {
      if (!this.gifFile) return
      this.img_list = []
      this.isSplitting = true
      this.splitProgress = 0
      this.pre_load_gif(this.gifFile)
    },
    async downloadFrame (item) {
      await downloadFile(item.url, item.file_name || 'frame.png')
    }
	}
}
</script>

<style>
.split-wrapper {
  padding: 8px 0;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1f2933;
}

.upload-area {
  border: 2px dashed #9fb3ff;
  border-radius: 16px;
  padding: 32px 16px;
  background: #f8f9ff;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 16px;
}

.upload-area--compact {
  padding: 20px 16px;
}

.upload-area:hover {
  border-color: #667eea;
  background: #f0f2ff;
}

.upload-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.upload-icon {
  font-size: 40px;
  margin-bottom: 4px;
}

.upload-text {
  font-size: 16px;
  color: #4f46e5;
  font-weight: 600;
}

.upload-hint {
  font-size: 12px;
  color: #9ca3af;
}

.hidden-gif-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.original-preview {
  margin-bottom: 16px;
}

.preview-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
}

.original-gif {
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.15);
}

.frames-list {
  margin-top: 8px;
}

.actions {
  margin: 12px 0;
}

.btn-primary {
  width: 100%;
  padding: 10px 0;
  border-radius: 8px;
  border: none;
  background: #667eea;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.frames-grid {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}

.frame-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: #f8f9ff;
  border-radius: 10px;
  margin-bottom: 8px;
}

.frame-thumb {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
}

.frame-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.frame-info {
  flex: 1;
  font-size: 13px;
  color: #4b5563;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 6px;
  border: none;
  background: #667eea;
  color: white;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.progress-container {
  margin: 16px 0;
  padding: 12px;
  background: #f8f9ff;
  border-radius: 8px;
}

.progress-label {
  font-size: 13px;
  color: #4f46e5;
  font-weight: 500;
  margin-bottom: 8px;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}
</style>